import { createSlice } from '@reduxjs/toolkit'

export const vcardSlice = createSlice({
  name: 'vcard',
  initialState: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    mobile: '',
    url: '',
    company: '',
    job: '',
    fax: '',
    address: '',
    city: '',
    postCode: '',
    country: '',
  },
  reducers: {
    setVCardField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    initializeVCard(state, action) {
      state.firstName = ''
      state.lastName = ''
      state.email = ''
      state.phone = ''
      state.mobile = ''
      state.url = ''
      state.company = ''
      state.job = ''
      state.fax = ''
      state.address = ''
      state.city = ''
      state.postCode = ''
      state.country = ''
    }
  }
})

export const {
  setVCardField,
  initializeVCard
} = vcardSlice.actions
export default vcardSlice.reducer